import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import benefitAccount from "@/views/gmTool/benefitAccount/benefitAccount.vue";
import welfareClass from "@/views/gmTool/welfareClass/welfareClass.vue";
import associationManagement from "@/views/gmTool/associationManagement/associationManagement.vue";
import welfareOperation from "@/views/gmTool/welfareOperation/welfareOperation.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "welfareManagement",
  components: {
    benefitAccount: benefitAccount,
    welfareClass: welfareClass,
    associationManagement: associationManagement,
    welfareOperation: welfareOperation
  },
  mixins: [gmTool],
  data: function data() {
    return {
      activeIndex: '0'
    };
  },
  activated: function activated() {},
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    modelChange: function modelChange(e) {
      this.activeIndex = e;

      if (e == 2) {
        this.$refs.associationManagement.updateList();
      } else if (e == 3) {
        this.$refs.welfareOperation.refresh();
      }
    }
  }
};